var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEndedIconBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 6.44772 0.447715 6 1 6H43C43.5523 6 44 6.44772 44 7C44 7.55228 43.5523 8 43 8H0.999999C0.447714 8 0 7.55228 0 7Z",
    fill: "#04B7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 11.4477 0.447715 11 1 11H43C43.5523 11 44 11.4477 44 12C44 12.5523 43.5523 13 43 13H0.999999C0.447714 13 0 12.5523 0 12Z",
    fill: "#04B7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16C0.447715 16 0 16.4477 0 17C0 17.5523 0.447716 18 1 18H23C23.5523 18 24 17.5523 24 17C24 16.4477 23.5523 16 23 16H1Z",
    fill: "#04B7EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 28.5C4.33579 28.5 4 28.8358 4 29.25V33.75C4 34.1642 4.33579 34.5 4.75 34.5C5.16421 34.5 5.5 34.1642 5.5 33.75V29.25C5.5 28.8358 5.16421 28.5 4.75 28.5Z",
    fill: "#04B7EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 25C0.895431 25 0 25.8954 0 27V36C0 37.1046 0.895431 38 2 38H42C43.1046 38 44 37.1046 44 36V27C44 25.8954 43.1046 25 42 25H2ZM42 26.5H2C1.72386 26.5 1.5 26.7239 1.5 27V36C1.5 36.2761 1.72386 36.5 2 36.5H42C42.2761 36.5 42.5 36.2761 42.5 36V27C42.5 26.7239 42.2761 26.5 42 26.5Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEndedIconBig);
export default __webpack_public_path__ + "static/media/OpenEndedIconBig.4fc13261959d0366fb83337747d2eed1.svg";
export { ForwardRef as ReactComponent };